import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IncidentDetailComponent } from './incident/incident-detail.component';

const routes: Routes = [
  { path: 'incidents', component: IncidentDetailComponent },
  { path: '', redirectTo: 'incidents', pathMatch: 'full' },
  { path: '**', redirectTo: 'incidents' },
];
export const AppRoutingModule: ModuleWithProviders<unknown> = RouterModule.forRoot(routes, { useHash: true });